import { render } from "./SimpleCaseSolution.html?vue&type=template&id=0bfece09&ts=true&external"
import script from "./SimpleCaseSolution.vue?vue&type=script&lang=ts"
export * from "./SimpleCaseSolution.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__